<template>
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.ClientInventory')" :categoryIcon="'scf-patrimoine'"
      :title="$t('sideMenu.DeviceImportList')" />

    <div style="max-width: 100%">
      <div class="row" style="
          align-content: flex-end;
          justify-content: flex-end;
          padding-top: 10px;
        "></div>
      <div class="row">
        <div class="col-md-4">
          <div class="input-group input-group-md">
            <div class="input-group-prepend sc-prepend-flex">
              <span class="input-group-text sc-custom-input-font-box" id="inputGroup-sizing-sm-1">
                <i class="scf-search"></i>
              </span>
            </div>
            <input id="searchFileInput" type="text" :placeholder="placeholderfile" @input="applyCustomFilters"
              class="form-control" aria-describedby="inputGroup-sizing-sm-1">
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group input-group-md">
            <div class="input-group-prepend sc-prepend-flex">
              <span class="input-group-text sc-custom-input-font-box" id="inputGroup-sizing-sm-2">
                <i class="scf-search sc-input-box-font"></i>
              </span>
            </div>
            <input id="searchReferenceInput" @input="applyCustomFilters" :placeholder="placeholder" type="text"
              class="form-control" aria-describedby="inputGroup-sizing-sm-2">
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group input-group-md">
            <div class="input-group-prepend sc-prepend-flex">
              <span class="input-group-text sc-custom-input-font-box" id="inputGroup-sizing-sm-3">
                <i class="scf-calendar sc-input-box-font"></i>
              </span>
            </div>
            <wj-input-date-range style="flex-grow: 1;" id="theInputDateRange" :alwaysShowCalendar="true"
              :rangeChanged="applyCustomFilters" :predefinedRanges="predefinedRanges" v-model:value="rangeStart"
              v-model:rangeEnd="rangeEnd" :closeOnSelection="closeOnSelection" :monthCount="monthCount"
              :weeksBefore="weeksBefore" :weeksAfter="weeksAfter" :handleWheel="false"
              aria-describedby="inputGroup-sizing-sm-3">
            </wj-input-date-range>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div style="flex: auto" v-if="componentKey > 0">
          <!-- group panel -->
          <OdataFlexGrid :key="componentKey" :Api="{
            base: urlOdata + 'api/v1/OData/',
            controller: 'DeviceImports',
          }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinition" :ColumnsDefinition="columns"
            :allowPinning="'SingleColumn'" :FilterColumns="[
              'SourceEnum',
              'ProcessingStatusEnum',
              'AcknowlegeFileName',
              'Records',
              'RecordsOk',
              'RecordsKo',
            ]" :displayLang="culture" v-on:initializedGrid="gridInitialized" v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'DeviceImportsList_v5'" :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')" v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="componentKey++" />
          <!-- END Grid -->
        </div>
        <loaderSpinner :loading="isLoading"></loaderSpinner>
        <p></p>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Swal from "sweetalert2";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import Helper from "@/Utils/Helper";
import "sweetalert2/dist/sweetalert2.min.css";
import Configs from "../../configs";
import "@grapecity/wijmo.styles/wijmo.css";
import * as wijmo from "@grapecity/wijmo";
import "@grapecity/wijmo.vue2.grid.filter";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
import "@grapecity/wijmo.vue2.core";
import { WjInputDateRange } from "@grapecity/wijmo.vue2.input";
import "@grapecity/wijmo.styles/wijmo.css";
import { DateTime } from "@grapecity/wijmo";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import LoaderSpinner from "../components/LoadingSpinner.vue";

export default defineComponent({
  name: "FileProcessing",
  inject: ["accessToken", "routePrefix", "currentScope"],
  components: {
    OdataFlexGrid,
    WjInputDateRange,
    ContentTitle,
    LoaderSpinner,
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        this.refreshContent(newVal);
      },
      deep: true
    },
    preselectedScope(newVal) {
      if (newVal) {
        console.log("PreselectedScope changed: ", newVal);
        this.mainService = new MainService(this.accessToken ?? this.$jwt.token, newVal);
        this.componentKey += 1;
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
        //this.componentKey++;
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== '')
        this.componentKey += 1;
    }
  },

  computed: {
    currentScopeView() {
      return this.preselectedScope ?? this.currentScope ?? this.$jwt.scope;
    },
    gridHeaders() {
      return {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': this.currentScopeView,
        'X-Custom-Filters': this.headerFilters || ""
      };
    },

  },
  data() {
    //this.$jwt.hasRole('dm-administrator')
    const sourceEnumFilterValues = [
      {
        id: "Manufacturer", label: computed(() => this.getTraductionFlux("Manufacturer")),
      },
      {
        id: "Mobility", label: computed(() => this.getTraductionFlux("Mobility")),
      },
      {
        id: "Assets", label: computed(() => this.getTraductionFlux("Assets")),
      },
      {
        id: "Cancelation", label: computed(() => this.getTraductionFlux("Cancelation")),
      },
    ];
    if (this.$jwt.hasRole('dm-administrator'))
      sourceEnumFilterValues.push({
        id: "ReturnToCommunStock", label: computed(() => this.getTraductionFlux("ReturnToCommunStock")),
      });
    return {
      headerFilters: null,
      isLoading: false,
      componentKey: 0,
      isPreselectedScope: false,
      preselectedScope: null,
      preselectedFilters: {},
      mainService: new MainService(this.$jwt.token, this.isPreselectedScope ? this.preselectedScope : this.currentScope),
      rangeStart: DateTime.weekFirst(new Date()),
      rangeEnd: DateTime.weekLast(new Date()),
      predefinedRanges: computed(() => {
        if (this.$i18n.locale == "fr-FR") {
          return this.getPredefinedRangesFR();
        } else return this.getPredefinedRangesEN();
      }),
      placeholder: computed(() =>
        this.$t("pages.DeviceImportList.SearchReference")
      ),
      placeholderfile: computed(() =>
        this.$t("pages.DeviceImportList.SearchFile")
      ),
      config: Configs,
      closeOnSelection: true,
      monthCount: 2,
      weeksBefore: 0,
      OdataFilter: null,
      weeksAfter: 0,
      theGrid: null,
      latestDataState: null,
      culture: computed(() => this.$i18n.locale),
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      filter: null,
      SearchReference: "",
      SearchFile: "",
      FiltersDefinition: [

        {
          binding: "SourceEnum",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: sourceEnumFilterValues,
        },
        // {
        //   binding: "ExternalId",
        //   hasValueFilter: false,
        //   hasConditionFilter: true,
        // },
        {
          binding: "ProcessingStatusEnum",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Failed",
              label: computed(() => this.getTraductionState("Failed")),
            },
            {
              id: "Successful",
              label: computed(() => this.getTraductionState("Successful")),
            },
            {
              id: "InProgress",
              label: computed(() => this.getTraductionState("InProgress")),
            },
            {
              id: "PartiallySuccessful",
              label: computed(() =>
                this.getTraductionState("PartiallySuccessful")
              ),
            },
            {
              id: "TechnicalFailure",
              label: computed(() => this.getTraductionState("TechnicalFailure")),
            },
            {
              id: "Pending",
              label: computed(() => this.getTraductionState("Pending")),
            }
          ],
        },
        {
          binding: "AcknowlegeFileName",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Records",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "RecordsOk",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "RecordsKo",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      columns: [
        {
          binding: "Id",
          width: "*",
          header: computed(() => this.$t("pages.DeviceImportList.columns.Id")),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "CreatedDate",
          width: "*",
          dataType: "Date",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.CreatedDate")
          ),
        },
        {
          binding: "SourceEnum",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.SourceEnum")
          ),
        },
        {
          binding: "ExternalId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.ExternalId")
          ),
        },
        {
          binding: "ProcessingStatusEnum",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.ProcessingStatusEnum")
          ),
        },
        {
          binding: "AcknowlegeFileName",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.AcknowlegeFileName")
          ),
        },
        {
          binding: "Records",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.Records")
          ),
        },
        {
          binding: "RecordsOk",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.RecordsOk")
          ),
        },
        {
          binding: "RecordsKo",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportList.columns.RecordsKo")
          ),
        },
        {
          binding: "References",
          width: "*",
          header: "References",
          visible: false,
          isTechnicalColumn: true,
        },
        // {
        //   binding: "FirmwarePackage",
        //   width: "*",
        //   header: computed(() =>
        //     this.$t("pages.FirmwareList.columns.FirmwareDescription")
        //   ),
        // },

        { header: "Actions", width: "*" },
      ],
      screenName: computed(() => this.$t('sideMenu.DeviceImportList')),
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") + "api/v1/OData/DeviceImports/export?",
      downloadAckRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportAcknowlegeContent?deviceImportId=", //https://localhost:44392/api/v1/DeviceImports/deviceImportAcknowlegeContent?deviceImportId=
      downloadInputRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportContent?deviceImportId=",
    };
  },
  methods: {
    applyCustomFilters: function () {
      if (!this.theGrid || !this.theGrid.collectionView) return;
      let searchRef = document.getElementById("searchReferenceInput").value,
        searchFile = document.getElementById("searchFileInput").value;
      let customInputFilters = [];

      this.SearchReference = searchRef;

      searchRef && searchRef.length > 0
        ? customInputFilters.push(`searchRef=${searchRef}`)
        : customInputFilters.push(`searchRef=`);

      searchFile && searchFile.length > 0
        ? customInputFilters.push(`searchFile=${searchFile}`)
        : customInputFilters.push(`searchFile=`);

      if (this.rangeStart && this.rangeEnd) {
        customInputFilters.push(`startDate=${this.rangeStart.toISOString()};endDate=${this.rangeEnd.toISOString()}`);
      }

      this.headerFilters = customInputFilters.length > 0 ? customInputFilters.join(';') : null;
      this.theGrid.collectionView.requestHeaders = this.gridHeaders;      
      this.theGrid.collectionView.load();
    },
    handleFilterInitialized(filter) {
      // Here you receive the emitted filter value
      this.OdataFilter = filter;

      // Now you can do whatever you want with the `filter` object
    },
    formatDateWijmo(date) {
      if (this.$i18n.locale == "fr-FR") {
        return wijmo.Globalize.format(date, "dd/MM/yyyy");
      }
      return wijmo.Globalize.format(date, "MM/dd/yyyy");
    },
    getPredefinedRangesEN: function () {
      let dt = DateTime,
        now = new Date();
      return {
        // custom
        "Custom Range": null,

        // days
        //'Today': [now, now],
        //'Yesterday': [dt.addDays(now, -1), dt.addDays(now, -1)],
        //'Tomorrow': [dt.addDays(now, +1), dt.addDays(now, +1)],

        // weeks
        "This Week": [dt.weekFirst(now), dt.weekLast(now)],
        "Last Week": [
          dt.weekFirst(dt.addDays(now, -7)),
          dt.weekLast(dt.addDays(now, -7)),
        ],

        // months
        "This Month": [dt.monthFirst(now), dt.monthLast(now)],
        "Last Month": [
          dt.monthFirst(dt.addMonths(now, -1)),
          dt.monthLast(dt.addMonths(now, -1)),
        ],
        // years
        "This Year": [dt.yearFirst(now), dt.yearLast(now)],
        "Last Year": [
          dt.addYears(dt.yearFirst(now), -1),
          dt.addYears(dt.yearLast(now), -1),
        ],
      };
    },
    getPredefinedRangesFR: function () {
      let dt = DateTime,
        now = new Date();
      return {
        // custom
        "Période perso": null,

        // days
        //'Today': [now, now],
        //'Yesterday': [dt.addDays(now, -1), dt.addDays(now, -1)],
        //'Tomorrow': [dt.addDays(now, +1), dt.addDays(now, +1)],

        // weeks
        "Cette semaine": [dt.weekFirst(now), dt.weekLast(now)],
        "Semaine dernière": [
          dt.weekFirst(dt.addDays(now, -7)),
          dt.weekLast(dt.addDays(now, -7)),
        ],
        // months
        "Ce mois": [dt.monthFirst(now), dt.monthLast(now)],
        "Mois dernier": [
          dt.monthFirst(dt.addMonths(now, -1)),
          dt.monthLast(dt.addMonths(now, -1)),
        ],
        // years
        "Cette année": [dt.yearFirst(now), dt.yearLast(now)],
        "Année dernière": [
          dt.addYears(dt.yearFirst(now), -1),
          dt.addYears(dt.yearLast(now), -1),
        ],
      };
    },
    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel`;
      }
      this.isLoading = true;
      this.mainService
        .ExportProcessedFile(exportUrl, this.headerFilters, this.gridHeaders)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            this.screenName,
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv`;
      }

      //  console.log("grid header ",this.gridHeaders["X-Custom-Filters"]);
      this.isLoading = true;
      this.mainService
        .ExportProcessedFile(exportUrl, this.headerFilters, this.gridHeaders)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            this.screenName,
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    DownloadFirmwareZip(e, p) {
      var Arr = this.base64ToArrayBuffer(e);
      this.saveByteArray(p, Arr);
      Swal.fire({
        position: "bottom-end",
        icon: "success",
        title: this.$t("pages.Utils.filedownloaded"),
        showConfirmButton: false,
        timer: 1500,
      });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/zip" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    DownloadInputFile(e) {
      this.isLoading = true;
      this.mainService
        .Export(this.downloadInputRoot + e.Id, this.gridHeaders)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.Download(e.ExternalId, type, response.data, false);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    DownloadAcknowlegeFile(e) {
      this.isLoading = true;
      this.mainService
        .Export(this.downloadAckRoot + e.Id, this.gridHeaders)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.Download(e.AcknowlegeFileName, type, response.data, false);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    gridInitialized(flexgrid) {
      let self = this;
      this.theGrid = flexgrid;

      // Apply a default sort only when no saved/user sort is active.
      if (this.theGrid.collectionView?.sortDescriptions?.length === 0) {
        this.theGrid.collectionView.sortDescriptions.push(
          new wijmo.SortDescription("CreatedDate", false)
        );
      }

      var downloadInputXmlFile = this.DownloadInputFile.bind(this);
      var downloadInputAckFile = this.DownloadAcknowlegeFile.bind(this);
      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type");
        if (!action) {
          let actionExternalId = e.target.getAttribute(
            "action-type-ExternalId"
          );
          if (!actionExternalId) {
            let actionAcknowlegeFileName = e.target.getAttribute(
              "action-type-AcknowlegeFileName"
            );
            if (!actionAcknowlegeFileName) {
              return;
            }
            //traitement actionAcknowlegeFileName
            var hitTestAcknowlegeFileName = flexgrid.hitTest(e);
            var dataGridAck =
              flexgrid.rows[hitTestAcknowlegeFileName.row].dataItem;
            downloadInputAckFile(dataGridAck);
            //fin traitement actionAcknowlegeFileName
            return;
          }
          //traitement action-type-ExternalId
          var hitTestExternalId = flexgrid.hitTest(e);
          var dataGrid = flexgrid.rows[hitTestExternalId.row].dataItem;
          downloadInputXmlFile(dataGrid);
          //fin traitement action-type-ExternalId
          return;
        }

        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;
        // self.$router.push({ path: "/CampaignDetail/" + JSON.stringify(data) });

        localStorage.setItem("SearchReference", self.SearchReference);

        localStorage.setItem("DeviceImportId", data.Id);
        localStorage.setItem("DeviceImportCreatedDate", data.CreatedDate);
        localStorage.setItem("DeviceImportSourceEnum", data.SourceEnum);
        localStorage.setItem("DeviceImportExternalId", data.ExternalId);
        localStorage.setItem(
          "DeviceImportProcessingStatusEnum",
          data.ProcessingStatusEnum
        );
        localStorage.setItem(
          "DeviceImportAcknowlegeFileName",
          data.AcknowlegeFileName
        );
        localStorage.setItem("DeviceImportRecords", data.Records);
        localStorage.setItem("DeviceImportRecordsOk", data.RecordsOk);
        localStorage.setItem("DeviceImportRecordsKo", data.RecordsKo);
        // self.$router.push({
        //   name: "FileProcessingDetails",
        // });
        self.$router.push({
          path: `/DmPortal/FileProcessingDetails/${this.currentScopeView}/${data.Id}`,
        });
      });

      this.applyCustomFilters();
    },
    exportPage(exportToType) {
      if (exportToType === "excel") {
        let book = wjcGridXlsx.FlexGridXlsxConverter.save(this.theGrid);
        book.sheets[0].name = "firmwares";
        book.save("FirmwareList.xlsx");
      }
    },
    downloadfile() {

    },
    substringIfGreaterThanTweenty(e) {
      if (e.length > 20) {
        return e.substring(0, 17).concat("", "...");
      } else return e;
    },
    formatColumns: function (s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;
        if (flex.columns[e.col].header == "Actions") {
          localStorage.setItem("SearchReference", this.SearchReference);
          const prefix = Helper.ComputeRoutePrefix(this.routePrefix);

          e.cell.innerHTML =
            '<a class="scf-searchPlus"  target="_blank" style="color:#6095D6;text-decoration: none;" href="' +
            prefix +
            "/DmPortal/FileProcessingDetails/" +
            `${this.isPreselectedScope ? this.preselectedScope : this.currentScopeView}` + "/" +
            s.rows[e.row].dataItem.Id +
            '"></a>';

          //   e.cell.innerHTML =
          //  '<svg style="color:blue;cursor:pointer;" action-type="show" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>';
        } else if (flex.columns[e.col].binding == "Description") {
          if (e.cell.textContent.trim().length > 20) {
            e.cell.innerHTML = wijmo.format(
              '<i action-type-description="showDescriptionInSwal">' +
              this.substringIfGreaterThanTweenty(e.cell.textContent.trim()) +
              "</i>",
              s.rows[e.row].dataItem
            );
          } else {
            e.cell.innerHTML = wijmo.format(e.cell.textContent.trim());
          }
        } else if (flex.columns[e.col].binding == "AcknowlegeFileName") {
          e.cell.innerHTML = wijmo.format(
            '<i style="cursor: pointer; color: blue" action-type-AcknowlegeFileName="DownloadAcknowlegeFile">' +
            e.cell.textContent.trim() +
            "</i>",
            s.rows[e.row].dataItem
          );
        } else if (flex.columns[e.col].binding == "ExternalId") {
          e.cell.innerHTML = wijmo.format(
            '<i style="cursor: pointer; color: blue" action-type-ExternalId="DownloadInputFile">' +
            e.cell.textContent.trim() +
            "</i>",
            s.rows[e.row].dataItem
          );
        } else if (flex.columns[e.col].binding == "CreatedDate") {
          e.cell.innerText = this.$d(s.rows[e.row].dataItem.CreatedDate, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });
        }
      }
    },
    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.State.${e}`);
    },
    getTraductionFlux: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.Source.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    refreshContent(newScopeVal) {
      if (newScopeVal && this.componentKey < 1) {
        this.isPreselectedScope = false;
        this.mainService = new MainService(this.accessToken ?? this.$jwt.token, newScopeVal);
        this.componentKey += 1;
      }
    }
  },
  mounted() {
    const e = new CustomEvent("component-ready");
    window.dispatchEvent(e);
    const preselectedScope = this.$route.params["scope"];
    if (preselectedScope?.length > 1) {
      this.filter = this.$route.params["reference"];
      document.getElementById("searchReferenceInput").value = this.filter;
      this.isPreselectedScope = true;
      this.preselectedScope = preselectedScope;
    }
    if (this.currentScope) {
      this.refreshContent(this.currentScope);
    }
  }
});
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}

.wj-inputnumber {
  width: 10em;
}

.params>div {
  margin-bottom: 0.5em;
}

label {
  width: 10em;
  text-align: right;
  margin-right: 0.5em;
}

body {
  margin-bottom: 36px;
}

.sc-custom-input-font-box {
  border-radius: 0;
}

.sc-input-box-font {
  font-size: 1.1rem;
}

.sc-prepend-flex {
  display: flex;
}

.input-group:focus-within {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
  z-index: 3;
  border-radius: .25rem;
}

.input-group .form-control:focus {
  box-shadow: none !important;
}
</style>
<style>
@import "https://use.fontawesome.com/releases/v5.8.1/css/solid.css";
</style>
<style scoped src="../assets/css/firmwareList.css"></style>
